import { api } from './apiClient';

export interface UsageBucket {
  costUsd: number;
  tokens: number;
}
export interface ConversationUsage {
  conversationId: string;
  title: string;
  agentId: string;
  costUsd: number;
  tokens: number;
  calls: number;
}
export interface RunUsage {
  runId: string;
  flowId: string | null;
  costUsd: number;
  tokens: number;
  calls: number;
  at: string;
}
export interface UsageSummary {
  totals: { costUsd: number; tokens: number; calls: number };
  byAgent: Record<string, UsageBucket>;
  byFlow: Record<string, UsageBucket>;
  byPerson: Record<string, UsageBucket>;
  byArea: Record<string, UsageBucket>;
  byModel: Record<string, UsageBucket>;
  byConversation: ConversationUsage[];
  byRun: RunUsage[];
}

export type BudgetUsageSummary = Pick<UsageSummary, 'byPerson' | 'byArea'>;

export interface UsageEvent {
  id: string;
  createdAt: string;
  modelId: string;
  kind: string;
  scope: string | null;
  agentId: string | null;
  flowId: string | null;
  personId: string | null;
  areaId: string | null;
  promptTokens: number;
  completionTokens: number;
  totalTokens: number;
  costUsd: number;
}

export interface Wallet {
  personId: string;
  monthlyBudget: number;
  monthlySpent: number;
  monthlyRemaining: number;
  topup: number;
  grants?: number; // saldo liberado pela área (grants aprovados)
  available: number;
}

export const usageService = {
  // Saldo do usuário logado (null se não houver pessoa vinculada = sem governança).
  async wallet(): Promise<Wallet | null> {
    const res = await api.get<{ wallet: Wallet | null }>('/usage/wallet');
    return res.wallet;
  },

  // Gasto do mês corrente agregado por agente/fluxo/pessoa/área/modelo.
  async summary(): Promise<UsageSummary> {
    return api.get<UsageSummary>('/usage/summary');
  },
  // A tela de orçamento precisa somente dos agregados por pessoa e área.
  async summaryForBudget(): Promise<BudgetUsageSummary> {
    return api.get<BudgetUsageSummary>('/usage/summary?view=budget');
  },
  async events(limit = 100): Promise<UsageEvent[]> {
    const res = await api.get<{ events: UsageEvent[] }>(`/usage/events?limit=${limit}`);
    return res.events;
  },
};
